import { useScrollReveal } from "../../../hooks/useScrollReveal";

export default function SolutionSection() {
  const { ref: sectionRef, visible } = useScrollReveal(0.08);
  const { ref: textRef, visible: textVisible } = useScrollReveal(0.15);

  return (
    <section
      ref={sectionRef as React.RefObject<HTMLElement>}
      className="relative w-full overflow-hidden bg-[#050507]"
      style={{ minHeight: "90vh" }}
    >
      {/* Full bleed image — right aligned */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/f6b058b616159f46e8a3076e0f470bfb.jpg"
          alt=""
          className="w-full h-full object-cover object-center"
          style={{
            opacity: visible ? 0.5 : 0,
            transform: visible ? "scale(1)" : "scale(1.04)",
            transition: "opacity 1.4s ease, transform 2s ease",
          }}
        />
        {/* Right-side text fade */}
        <div className="absolute inset-0 bg-gradient-to-l from-[#050507] via-[#050507]/70 to-transparent" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#050507]/80 via-transparent to-[#050507]/60" />
      </div>

      {/* Content — right aligned */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 py-36 flex items-center justify-end min-h-[90vh]">
        <div
          ref={textRef as React.RefObject<HTMLDivElement>}
          className="max-w-xl text-right"
          style={{
            opacity: textVisible ? 1 : 0,
            transform: textVisible ? "translateX(0)" : "translateX(40px)",
            transition: "opacity 1s ease 0.2s, transform 1s ease 0.2s",
          }}
        >
          <span className="text-xs font-semibold uppercase tracking-[0.18em] text-[#4ADE80]/80 mb-5 block">
            The Solution
          </span>
          <h2
            className="font-extrabold text-white leading-[0.95] tracking-[-0.035em] mb-8"
            style={{
              fontFamily: "'Space Grotesk', sans-serif",
              fontSize: "clamp(2.8rem, 5vw, 5.5rem)",
            }}
          >
            We Build the Systems That{" "}
            <span className="text-[#4ADE80]">Hold Everything Together</span>
          </h2>
          <p
            className="text-white/55 leading-relaxed mb-10"
            style={{ fontFamily: "'Inter', sans-serif", fontSize: "1.1rem" }}
          >
            GroundsWell AI replaces operational gaps with structured intelligence. Every lead,
            task, and workflow is captured, managed, and optimized—without manual effort.
          </p>

          <div className="space-y-4 flex flex-col items-end">
            {[
              "Every lead captured automatically",
              "Workflows run without manual input",
              "Operations unified into one system",
            ].map((point, i) => (
              <div
                key={point}
                className="flex items-start gap-4 flex-row-reverse"
                style={{
                  opacity: textVisible ? 1 : 0,
                  transform: textVisible ? "translateX(0)" : "translateX(20px)",
                  transition: `opacity 0.8s ease ${0.4 + i * 0.12}s, transform 0.8s ease ${0.4 + i * 0.12}s`,
                }}
              >
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-checkbox-circle-fill text-[#4ADE80] text-base" />
                </div>
                <span className="text-sm text-white/50 leading-relaxed">{point}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
